export { WorkflowTable } from './libs/workflow-table';
export { WorkflowDetail } from './libs/workflow-detail';
export { WorkflowDetailComponent } from './libs/workflow-detail-component';
